<template>
  <div class="ai">
    <div class="ai-container">
      <div>
        <img src="@/images/investment/shapes.png" class="image-title" />
      </div>
      <h1>How OOYYO is increasing valuation?</h1>
      <h2>
        AI, predictive pricing and merchandising data, saving car dealer
        industry hundreds of millions of dollars.
      </h2>

      <div class="row">
        <div class="col-6">
          <p>
            In used-car retailing every day counts because every car represents
            both a big investment and an opportunity cost. Having this insight
            is key to maximizing inventory turn and thus profits.
          </p>
          <p>
            After crunching mounds of data, OOYYO shows how price changes can
            affect how long a vehicle stays in inventory.
          </p>
          <p>
            Car sellers can use <strong>OOYYO DATA</strong> to buy, sell, and
            merchandise inventory accurately and effectively.
          </p>
          <div class="subtext-1">AI powered</div>
          <p>
            <strong>Combined with OOYYO AI-powered analytics</strong>, this level of automotive
            data and insights is not available anywhere else in the European
            market!
          </p>
          <p>
            OOYYO can set up many other predictive models and <strong>save hundreds of
            millions of dollars</strong> in large car operations expenses.
          </p>
        </div>
        <div class="col-6">
          <img src="@/images/investment/ai.svg" class="image-content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
